/**
 * Created by spepa on 20.12.2022
 */

const PromotionSaleWindow = CleverappsWindow.extend({
    ctor: function (offer) {
        this.logic = offer.logic;
        this.bundle = bundles[offer.bundle];

        this._super(offer);
    },

    onWindowLoaded: function () {
        this.vertical = this.isVertical();

        this._super({
            name: "PromotionSaleWindow",
            noBackground: true,
            notCloseByTouchInShadow: true,
            closeButtonDelay: true,
            fireworks: true,
            content: this.createContent(),
            openSound: this.bundle.urls.bonussale_showup_effect,
            styles: this.getWindowStyles()
        });

        cleverapps.focusManager.hideAllControls();
        cleverapps.focusManager.showControlsWhileFocused(["MenuBarGoldItem", "MenuBarCoinsItem", "MenuBarLivesItem"]);

        this.logic.onUpdateLots = this.createListener(this.onLotBought.bind(this));
    },

    onShow: function () {
        this._super();

        this.runAction(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.CallFunc(this.logic.onWindowShowUpFinished.bind(this.logic))
        ));
    },

    onResize: function () {
        this._super();

        if (this.vertical !== this.isVertical()) {
            this.vertical = this.isVertical();
            this.params.styles = this.getWindowStyles();
            this.rebuildWindow(this.createContent());
        }
    },

    isVertical: function () {
        return cleverapps.resolution.isVertical() && this.bundle.jsons.bonussale_vertical_bg;
    },

    getWindowStyles: function () {
        const styles = {
            windowShowUpAnimation: { name: "slideUp", force: true }
        };

        if (this.vertical) {
            Object.assign(styles, cleverapps.styles.PromotionSaleWindow[this.logic.offer.type].verticalWindow || {});
        }

        return styles;
    },

    createContent: function () {
        const styles = cleverapps.styles.PromotionSaleWindow[this.logic.offer.type];

        const json = this.vertical ? this.bundle.jsons.bonussale_vertical_bg : this.bundle.jsons.bonussale_bg;

        const content = this.content = new cleverapps.Spine(json);
        content.setAnimationAndIdleAfter("open", "idle");

        let lotsSlot = content.hasSlot("slot_lots") && content.getSlot("slot_lots");
        if (!lotsSlot) {
            lotsSlot = new cc.Node();
            content.addChild(lotsSlot, 1);
            lotsSlot.setAnchorPoint(0.5, 0.5);
            lotsSlot.setAlignment(styles.lots);
            if (styles.lots.width !== undefined) {
                lotsSlot.setContentSize(styles.lots);
            }
        }
        let descriptionSlot = content.hasSlot("slot_description") && content.getSlot("slot_description");
        if (!descriptionSlot) {
            descriptionSlot = new cc.Node();
            content.addChild(descriptionSlot);
            descriptionSlot.setAnchorPoint(0.5, 0.5);
            descriptionSlot.setAlignment(styles.description);
            if (styles.description.width !== undefined) {
                descriptionSlot.setContentSize(styles.description);
            }
        }

        const lots = this.lots = this.logic.getLots().map((lot, ind) => {
            const lotNode = new PromotionSaleLot(lot, this.logic);
            lotNode.setLocalZOrder(2 - ind);
            return lotNode;
        });

        const lotsLayout = new cleverapps.Layout(lots, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.lots.marginX
        });
        lotsSlot.addChild(lotsLayout);
        lotsLayout.setAlignment(lotsSlot.width / 2, lotsSlot.height / 2);

        const description = cleverapps.UI.generateOnlyText(Messages.get("PromotionSaleWindow.description"), cleverapps.styles.FONTS.BONUSBG_DESCRIPTION);
        descriptionSlot.addChild(description);

        description.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        description.setDimensions(descriptionSlot.width, descriptionSlot.height);
        description.setAlignment(descriptionSlot.width / 2, descriptionSlot.height / 2);

        if (!this.vertical) {
            this.createHeader();
        }

        this.createTitle();
        this.createTimer();
        return content;
    },

    createHeader: function () {
        const styles = cleverapps.styles.PromotionSaleWindow[this.logic.offer.type];

        const json = this.bundle.jsons.bonussale_header;

        if (json) {
            const header = new cleverapps.Spine(json);
            if (header.hasAnimation("open") && header.hasAnimation("idle")) {
                header.setAnimationAndIdleAfter("open", "idle");
            } else {
                header.setAnimation(0, "animation", false);
            }
            header.setAlignment(styles.header);
            this.content.addChild(header);
        }
    },

    createTitle: function () {
        const styles = cleverapps.styles.PromotionSaleWindow[this.logic.offer.type];

        let titleSlot = this.content.hasSlot("slot_title") && this.content.getSlot("slot_title");
        if (!titleSlot) {
            titleSlot = new cc.Node();
            this.content.addChild(titleSlot);
            titleSlot.setAnchorPoint(0.5, 0.5);
            titleSlot.setAlignment(styles.title);
            if (styles.title.width !== undefined) {
                titleSlot.setContentSize(styles.title);
            }
        }

        const msg = Messages.has(`PromotionSaleWindow.${this.logic.offer.name}.title`) || Messages.get("PromotionSaleWindow.title");
        const title = cleverapps.UI.generateOnlyText(msg, styles.title.font || cleverapps.styles.FONTS.BONUSBG_TITLE);
        titleSlot.addChild(title);

        title.fitTo(titleSlot.width, titleSlot.height);
        title.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
    },

    createTimer: function () {
        const styles = cleverapps.styles.PromotionSaleWindow[this.logic.offer.type].timer;
        if (!styles) {
            return;
        }

        const countDown = new cleverapps.CountDown(this.logic.getTimeLeft(), {
            onFinish: this.close.bind(this)
        });
        const timer = new cleverapps.CountDownView(countDown, {
            font: cleverapps.styles.FONTS.BONUSBG_TIMER
        });
        timer.setAlignment(styles);
        this.content.addChild(timer);
    },

    onLotBought: function () {
        this.lots.forEach((lotView) => {
            lotView.updateState();
        });

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(() => {
                if (!this.closed) {
                    this.close();
                }
            })
        ));
    },

    listBundles: function (offer) {
        return [offer.bundle];
    },

    getPerson: function () {
        return cleverapps.styles.PromotionSaleWindow[this.logic.offer.type].person || cleverapps.persons.choose("jihn", "dwarf");
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BONUSBG_TITLE: {
        size: 100,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    BONUSBG_TIMER: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    BONUSBG_DESCRIPTION: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    }
});

cleverapps.styles.PromotionSaleWindow = {};
cleverapps.styles.PromotionSaleWindow[Offers.TYPES.PROMOTION_SALE] = {
    title: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 452 },

        width: 440,
        height: 110
    },

    description: {
        x: { align: "center", dx: -10 },
        y: { align: "bottom", dy: -20 },

        width: 1200,
        height: 70
    },

    header: {
        x: { align: "center" },
        y: { align: "top", dy: -40 }
    },

    lots: {
        x: { align: "center", dx: -8 },
        y: { align: "center", dy: -86 },

        marginX: 32
    },

    verticalWindow: {
        Background: {
            padding: {
                x: -15
            }
        }
    }
};
cleverapps.styles.PromotionSaleWindow[Offers.TYPES.CLPROMOTION_SALE] = cleverapps.styles.PromotionSaleWindow[Offers.TYPES.PROMOTION_SALE];
